import { useLocation, useNavigate, useParams } from "react-router-dom";
import Title from "../components/Title";
import Container from "../components/Container";
import useStoryDetail from "../hooks/useStoryDetail";
import Loader from "../components/Loader";
import useRandom from "../hooks/useRandom";
import useWindowResize from "../hooks/useWindowResize";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useEffect, useState } from "react";

import BackButton from "../components/BackButton";

const SIZE_WIDTH_CLASS: Record<PhotoSize, string> = {
  gross: "w-full",
  mittel: "w-full md:w-1/2",
  klein: "w-full md:w-1/3",
}

const Story = () => {

  let { id } = useParams();
  const { story, loading } = useStoryDetail(id)
  const { seed } = useRandom(5)

  const { isMobile } = useWindowResize()

  const [index, setIndex] = useState(-1);

  const [detailPhotos, setDetailPhotos] = useState<PhotoToCreate[]>([])

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (story && story.photos) {
      const mainPhoto = story.photos.find(p => p.role === "main") ?? story.photos[0]
      setDetailPhotos(story.photos.filter(p => p.id !== mainPhoto?.id))
    }
  }, [story])

  const slides = detailPhotos.map(photo => ({
    src: photo.url,
    width: photo.width,
    height: photo.height
  }))

  const handleClickBack = () => {
    if(location && location.state && location.state.referrer){
      navigate(location.state.referrer)
    }
    else{
      navigate("/")
    }
  }

  return (
    <div>
      <Container className="pb-4">

      <div className="relative mt-4">
          <BackButton onClick={handleClickBack} className={`
          ${isMobile ? "" : "absolute -left-14 origin-center"}
          block scale-150  origin-top`} />
        </div>
        <Title className="mt-8">{story?.title}</Title>

        <div dangerouslySetInnerHTML={{ __html: story?.details ?? "" }} />

        <div className="mt-8 flex flex-wrap -mx-2">
          {
            detailPhotos.map((photo, photoIndex) => (
              <div key={photo.id} className={`${SIZE_WIDTH_CLASS[photo.size ?? "mittel"]} px-2 mb-4`}>
                <img
                  src={photo.url}
                  alt={photo.title || ""}
                  className="w-full h-auto object-cover cursor-pointer rounded"
                  onClick={() => setIndex(photoIndex)}
                />
              </div>
            ))
          }
        </div>

        <Lightbox
          slides={slides}
          open={index >= 0}
          index={index}
          close={() => setIndex(-1)}
          // enable optional lightbox plugins
        />

        {
          // Loader
          loading && <Loader seed={seed} />
        }
      </Container>
    </div>
  )
}

export default Story
